// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  searchParams: {},
  resultDetails: {},
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  TaxCodeOrgName: null,
  upLoadImage: {}, //图片地址
  moduleList: [], //授权模块枚举
};
export default modal;
